<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-8 col-8 mb-1">
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary ml-2"
            >
              <i class="fa fa-edit"></i> Details
            </button>
            <download-excel
              :data="selectedItems"
              name="EmsBlockUserAPI-selected-report.csv"
              type="csv"
              style="float: left"
            >
              <button class="btn btn-primary ml-2">
                <i class="fa fa-download"></i>
                Export selected
              </button>
            </download-excel>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="message.type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <div class="accordion p-3" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.accordion-1
                variant="neutral"
                class="text-left"
                >Search Transaction Criteria
                <span class="when-opened ml-3">
                  <i class="fa fa-arrow-down" />
                </span>
                <span class="when-closed ml-3">
                  <i class="fa fa-arrow-right" />
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    brand
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="BrandCodeModel"
                      :options="brandCodeOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    transaction date
                  </label>
                  <div class="col-sm-3">
                    <date-picker
                      v-model="timeFilter"
                      range
                      confirm-text="confirm"
                      confirm
                      editable
                      clearable
                      :default-value="timeFilter"
                      value-type="YYYY-MM-DD"
                      @confirm="onDateFilterSubmit"
                      id="DateRange"
                    ></date-picker>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    query by
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="PropertyFilterModel"
                      :options="PropertyFilterList"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                  <label
                    class="col-form-label form-control-label text-sm pl-0"
                    >{{ ConditionFilterModel }}</label
                  >
                  <div class="col-sm-4 ml-0">
                    <input
                      v-model="ValueFilterModel"
                      class="form-control mx-input"
                    />
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                   is Blocked
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="IsBlokedModel"
                      :options="IsBlokedOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mt-3 row">
                  <div class="col-sm-2 col-form-label form-control-label"></div>
                  <button
                    v-on:click="onSearchFilter"
                    class="btn btn-warning ml-3"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                  <button
                    v-on:click="onSearchExport"
                    class="btn btn-warning ml-2"
                  >
                    <i class="fa fa-download"></i> Search and Export
                  </button>
                  <button
                    v-on:click="onResetFilter"
                    class="btn btn-neutral ml-2"
                  >
                    <i class="fa fa-times"></i> reset query
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @on-all-select-rows="onSelectAllRow"
        >
          <template slot="action_button" slot-scope="props">
            <button
              :disabled="disableUnblockUserButton(props.row)"
              v-on:click="UnblockUserAction(props.cell_value)"
              class="btn btn-primary ml-2"
            >
            Unblock User
            </button>
        </template>
        </vue-bootstrap4-table>
        <div class="overflow-auto mt-3">
          <nav>
            <ul class="pagination b-pagination justify-content-center">
              <li class="col-12 p-0 pl-2">
                <label class="ml-2">Go to page: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="currentPage"
                  :options="arrayPages()"
                  required
                ></b-form-select>
                <b-button
                  v-if="currentPage != 1"
                  v-on:click="onLoadData(currentPage - 1)"
                  class="ml-3 mr-1 btn-sm btn-neutral"
                >
                  <i class="fa fa-less-than"></i>
                </b-button>
                <b-button
                  v-if="currentPage != totalPages"
                  v-on:click="onLoadData(currentPage + 1)"
                  class="ml-1 mr-3 btn-sm btn-neutral"
                >
                  <i class="fa fa-greater-than"></i>
                </b-button>

                <label class="ml-2">Show rows: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="itemPerPage"
                  :options="ItemPerPageList"
                  required
                ></b-form-select>
                <label
                  >{{ itemPerPage * currentPage - itemPerPage + 1 }} -
                  {{
                    currentPage == totalPages
                      ? totalItems
                      : itemPerPage * currentPage
                  }}
                  of {{ totalItems }}
                </label>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <modal :show.sync="showModalCreate" modal-classes="modal-md">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Block User API Report
      </h3>
      <table class="table table-striped">
        <tr>
          <td>Brand</td>
          <td>{{ this.BlockUserApiModel.brand_code }}</td>
        </tr>
        <tr>
          <td>user</td>
          <td>{{ this.BlockUserApiModel.user }}</td>
        </tr>
        <tr>
          <td>ip_address</td>
          <td>{{ this.BlockUserApiModel.ip_address }}</td>
        </tr>
        <tr>
          <td>Header</td>
          <td>{{ this.BlockUserApiModel.header }}</td>
        </tr>
        <tr>
          <td>Detail</td>
          <td>{{ this.BlockUserApiModel.detail }}</td>
        </tr>
        <tr>
          <td>Is Blocked</td>
          <td>{{ this.BlockUserApiModel.is_block }}</td>
        </tr>
        <tr>
          <td>Block_type</td>
          <td>{{ this.BlockUserApiModel.block_type }}</td>
        </tr>
        <tr>
          <td>Create Date</td>
          <td>{{ this.BlockUserApiModel.create_date }}</td>
        </tr>
        <tr>
          <td>Modify Date</td>
          <td>{{ this.BlockUserApiModel.modify_date }}</td>
        </tr>
        <tr></tr>
      </table>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import "vue2-datepicker/index.css";
import api_loyalty from "../api/api";
import NProgress from "nprogress";
import axios from "axios";

export default {
  name: "configList",
  data() {
    return {
      SummaryData: [],
      totalItems: 0,
      totalPages: 0,
      isCompletedLoadAllItems: false,
      nextToken: null,
      ListNextToken: [],
      itemPerPage: 50,
      ItemPerPageList: [50, 100, 500, 1000, 5000],
      currentPage: 1,
      IsConditionFilterDisabled: true,
      BrandCodeModel: "PHFortune",
      ChartBrandCodeModel: "PHFortune",
      DateRangeModel: null,
      ValueFilterModel: "",
      PropertyFilterModel: "user",
      ConditionFilterModel: "is",
      IsBlokedModel: "",
      PropertyFilterList: [
        { text: "User", value: "user" },
        { text: "Block Type", value: "block_type" },
        { text: "Header", value: "header" },
        { text: "Detail", value: "detail" },
      ],
      showLoadButton: true,
      timeFilter: [],
      filter: {
        brand_code: "",
        start_date: "",
        end_date: "",
        user: "",
        is_block:"",
        block_type: "",
        header: "",
        detail: "",
      },
      allTransaction: [],
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      IsBlokedOption: [
        { text: "All", value: "" },
        { text: "True", value: "1" },
        { text: "False", value: "0" },
      ],
      titlePopup: "Create",
      message: null,
      BlockUserApiModel: {
        id: "",
        brand_code: "",
        user: "",
        ip_address: "",
        header: "",
        detail: "",
        is_block: false,
        block_type: "",
        create_date: "",
        modify_date: "",
      },
      showModalCreate: false,
      showModalDetail: false,
      allMerchants: [],
      rows: [],
      columns: [
        {
          label: "Action",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Id",
          name: "id",
          row_text_alignment: "text-left",
        },
        {
          label: "user",
          name: "user",
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Is blocked",
          name: "is_block",
          sort: true,
        },
        {
          label: "Ip Address",
          name: "ip_address",
          sort: true,
        },
        {
          label: "header",
          name: "header",
          sort: true,
        },
        {
          label: "Detail",
          name: "detail",
          sort: true,
        },
        {
          label: "Block Type",
          name: "block_type",
          sort: true,
        },
        
        {
          label: "Create Date",
          name: "create_date",
          sort: true,
        },

      ],
      config: {
        pagination: false,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 8,
        per_page: this.itemPerPage ? this.itemPerPage : 50,
        checkbox_rows: false,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: true,
        card_mode: false,
        selected_rows_info: true,
        global_search: {
          visibility: false,
        },
        show_refresh_button: false,
        show_reset_button: false,
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    let momNow = this.$moment(new Date().toUTCString());
    let filterEndDate = momNow.format("YYYY-MM-DD");
    let filterStartDate = momNow.add(-1, "months").format("YYYY-MM-DD");
    this.timeFilter.push(filterStartDate);
    this.timeFilter.push(filterEndDate);
    this.filter.start_date = filterStartDate;
    this.filter.end_date = filterEndDate;
    this.DateRangeModel = {
      start_date: filterStartDate,
      end_date: filterEndDate,
    };
    this.onLoadData();
    this.selectedItems.push(this.BlockUserApiModel);
  },
  methods: {
    arrayPages() {
      var result = [];
      for (let index = 0; index < this.totalPages; index++) {
        result.push({ text: index + 1, value: index + 1 });
      }
      return result;
    },
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('blockuserapireport')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('blockuserapireport')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }
    },
    onResetFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        user: "",
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
        block_type: "",
        header:"",
        detail: "",
        is_block: this.IsBlokedModel,
      };

      this.onLoadData();
      this.ValueFilterModel = "";
      this.PropertyFilterModel = "id";
      this.ConditionFilterModel = "is";
    },
    onSearchFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        user: "",
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
        block_type: "",
        header:"",
        detail: "",
        is_block: this.IsBlokedModel,
      };
      switch (this.PropertyFilterModel) {
        case "user":
          this.filter.user = this.ValueFilterModel;
          break;
        case "block_type":
          this.filter.block_type = this.ValueFilterModel;
          break;
        case "header":
          this.filter.header = this.ValueFilterModel;
          break;
        case "detail":
          this.filter.detail = this.ValueFilterModel;
          break;
        default:
          break;
      }
      this.onLoadData();
    },
    async onSearchExport() {
      this.onSearchFilter();
      NProgress.start();
      try {
        let response = await API.graphql({
          query: queries.exportEmsBlockUserAPI,
          variables: {
            filter: this.filter,
            filename: "BlockUserAPIReport",
          },
        });
        var presign = response.data.exportEmsBlockUserAPI;

         let date_ob = new Date();
        let date = ("0" + date_ob.getDate()).slice(-2);
        let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
        let year = date_ob.getFullYear();
        let minutes = date_ob.getMinutes();
        let second = date_ob.getSeconds();
        var filename= `BlockUserAPIReport_${year}-${month}-${date}-${minutes}${second}.csv`;
        
        axios
          .get(presign, { responseType: 'arraybuffer' })
          .then((response) => {
            const a = document.createElement("a");
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            console.log('end download');
          })

        NProgress.done();
        //document.location.href = presign;
      } catch (error) {
        console.log(error);
        NProgress.done();
      }
    },
    onDateFilterSubmit(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.filter.start_date = momStart;
      this.filter.end_date = momEnd;
      this.DateRangeModel = {
        start_date: momStart,
        end_date: momEnd,
      };
    },
    async onLoadData(selectedPage) {
      try {
        NProgress.start();

        var startDate = this.DateRangeModel.start_date + " 00:00:00";
        this.filter.start_date = this.$moment(
          new Date(startDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();
        var endDate = this.DateRangeModel.end_date + " 23:59:59";
        this.filter.end_date = this.$moment(
          new Date(endDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();

        this.filter.brand_code = this.BrandCodeModel;
        this.currentPage = selectedPage ? selectedPage : 1;
        let response = await API.graphql({
          query: queries.listEmsBlockUserAPIPagination,
          variables: {
            pageSize: this.itemPerPage,
            pageNumber: this.currentPage,
            filter: this.filter,
          },
        });
        this.rows =
          response.data.listEmsBlockUserAPIPagination.items;
        this.totalPages =
          response.data.listEmsBlockUserAPIPagination.totalPages;
        this.totalItems =
          response.data.listEmsBlockUserAPIPagination.totalItems;
        this.allTransaction = this.rows;
        NProgress.done();
      } catch (error) {
        console.log(error);
        NProgress.done();
      }
    },
    onSelectAllRow(payload) {
      this.selectedItems = payload.selected_items;
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      console.log(this.selectedItems);
      if (
        payload.selected_items.length > 1 ||
        payload.selected_items.length == 0
      ) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.BlockUserApiModel = this.allTransaction.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.showModalCreate = true;
      this.titlePopup = "Details";
    },
    disableUnblockUserButton(data){
      if(data.is_block == false){
        return true;
      }
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.function.toLowerCase().includes('unblock-user-api')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.function.toLowerCase().includes('unblock-user-api')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      if (isChe || isFortune || isAdministrator || this.$store.getters.isCheAdmin || this.$store.getters.isFortuneAdmin) {
        return false;
      } else {
        return true;
      }
    },
    UnblockUserAction(id){
      console.log(this.BrandCodeModel);
      api_loyalty
        .UnBlockUserAPI(this.BrandCodeModel, id)
        .then((data) => {
          console.log(data);
          if(data.isSuccess == true){
            this.message = {
              message: "Unblock User successful.",
              type: "success",
            };
          }else{
            this.message = {
              message: "Unblock User  Failed."+ data.message,
              type: "danger",
            };
          }
        this.onLoadData();
        })
        .catch((e) => {
          console.log(e);
          this.message = {
            message: "Unblock User." ,
            type: "danger",
          };
        });
    },
  },
  components: {
    VueBootstrap4Table,
  },
  watch: {
    PropertyFilterModel: function (val) {
      if (val == "header" || val == "detail") {
        this.ConditionFilterModel = "contains";
      } else {
        this.ConditionFilterModel = "is";
      }
      console.log(val);
    },
    itemPerPage: function () {
      this.config.per_page = this.itemPerPage;
      this.onLoadData();
    },
    currentPage: function () {
      this.onLoadData(this.currentPage);
    },
  },
};
</script>
<style></style>
